var React = require('react');

function StickyNote (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M448 352H336a16 16 0 0 0-16 16v112H24a23.94 23.94 0 0 1-24-23.88V56a23.94 23.94 0 0 1 23.88-24H424a23.94 23.94 0 0 1 24 23.88V352z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M320 480V368a16 16 0 0 1 16-16h112v6.1a23.9 23.9 0 0 1-7 16.9l-98 98a24 24 0 0 1-17 7z","className":"fa-primary","key":2})]);
}

StickyNote.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = StickyNote;

StickyNote.default = StickyNote;
